export default __webpack_public_path__ + "static/media/rightBaloons.2c01ecaf.gif";